module.exports = __webpack_public_path__ + "img/main.ef6c36eb.jpg";